import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import { AuthUser } from './AuthUser'

import { PedidosPorDiaXLS } from '../views/XLS/PedidosPorDiaXLS'

import { formatNumber } from '../utils/formats';

export const PedidosPorDiaTable = ({ data, resumenFacturado, resumenPedido }) => {

  const { user } = AuthUser()

  const navigate = useNavigate();

  const [finalUniqueDates, setFinalUniqueDates] = useState([]);
  const [finalSortedVendors, setFinalSortedVendors] = useState([]);
  const [finalVendorData, setFinalVendorData] = useState([]);

  const flete = 0.031

  // Function to determine if a date is a weekend
  const isWeekend = dateStr => {
    const date = new Date(dateStr);
    const dayOfWeek = date.getDay();
    return dayOfWeek === 5 || dayOfWeek === 6; // Sunday (0) or Saturday (6)
  };

  // State for sorting Monto Pedido and Monto Facturado
  const [sortOrder, setSortOrder] = useState('asc');
  const [sortColumn, setSortColumn] = useState('TotalPedido'); // Default sorting by Monto Pedido

  // Get unique dates
  useEffect(() => {
    if (data && data.length > 0) {
      const uniqueDates = [...new Set(data.map(item => item.Fecha))];
      setFinalUniqueDates(uniqueDates);
    }
  }, [data]);

  useEffect(() => {
    if (data && data.length > 0) {
      const uniqueVendors = [...new Set(data.map(item => item.CodVendedor))];
      const sortedVendors = [...uniqueVendors];
      sortedVendors.sort((a, b) => {
        const valueA = data.find(item => item.CodVendedor === a)[sortColumn] || 0;
        const valueB = data.find(item => item.CodVendedor === b)[sortColumn] || 0;
        return sortOrder === 'asc' ? valueA - valueB : valueB - valueA;
      });
      setFinalSortedVendors(sortedVendors);
    }
  }, [data, sortColumn, sortOrder]); // Run this effect whenever `data`, `sortColumn`, or `sortOrder` changes

  useEffect(() => {
  if (data && data.length > 0 && finalSortedVendors.length > 0) {
    const newVendorData = finalSortedVendors.map(vendor => {
      // Mapeo rápido de los pedidos existentes
      const vendorItems = data.filter(item => item.CodVendedor === vendor);
      const mapByDate = Object.fromEntries(
        vendorItems.map(item => [item.Fecha, item])
      );
      // Rellenar todas las fechas
      return finalUniqueDates.map(date => {
        if (mapByDate[date]) {
          return mapByDate[date];
        }
        // Si no existe, devuelvo un objeto con Pedidos = 0
        const sample = vendorItems[0] || {};
        return {
          Fecha: date,
          CodVendedor: vendor,
          Nombre: sample.Nombre || '',
          nroPedidos: sample.nroPedidos || 0,
          TotalPedido: sample.TotalPedido || 0,
          TotalFacturado: sample.TotalFacturado || 0,
          Pedidos: 0,
          sectores: sample.sectores || ''
        };
      });
    });
    setFinalVendorData(newVendorData);
  }
}, [data, finalSortedVendors, finalUniqueDates]);

  // Function to toggle the sorting order and column
  const toggleSortOrder = (column) => {
    if (column === sortColumn) {
      setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
    } else {
      setSortOrder('asc');
      setSortColumn(column);
    }
  };

  // Render the table header with dates
  const renderTableHeader = () => {
    const formatDate = (dateStr) => {
      const [year, month, day] = dateStr.split('-');
      return `${day}/${month}/${year}`;
    };

    

    return (
      <tr className='bg-belmeny text-light text-center pb-3'>
        <th>Vendedor</th>
        {(user.CodGerente === 'HABOULMOUNA') ? <th>Zona</th> : null}
        <th
          onClick={() => toggleSortOrder('nroPedidos')}
          style={{ cursor: 'pointer' }}
        >
          # Pedidos
          {sortColumn === 'nroPedidos' ? ` ${sortOrder === 'asc' ? '▲' : '▼'}` : ''}
        </th>
        <th
          onClick={() => toggleSortOrder('TotalPedido')}
          style={{ cursor: 'pointer' }}
        >
          Monto Pedido
          {sortColumn === 'TotalPedido' ? ` ${sortOrder === 'asc' ? '▲' : '▼'}` : ''}
        </th>
        <th
          onClick={() => toggleSortOrder('TotalFacturado')}
          style={{ cursor: 'pointer' }}
        >
          Monto Facturado
          {sortColumn === 'TotalFacturado' ? ` ${sortOrder === 'asc' ? '▲' : '▼'}` : ''}
        </th>
        {finalUniqueDates.map(date => (
          <th key={date}>
            {formatDate(date)}
          </th>
        ))}
      </tr>
    );
  };

  // Render the table rows for each vendor
  // 2) Reemplaza tu renderTableRows por esto:
const renderTableRows = () => {
  return finalVendorData.map((vendorItems, idx) => {
    if (!vendorItems || vendorItems.length === 0) return null;

    const {
      CodVendedor,
      Nombre,
      nroPedidos,
      TotalPedido,
      TotalFacturado,
      sectores
    } = vendorItems[0];

    const totalPedidoSinFlete    = Number(TotalPedido);
    const totalFacturadoSinFlete = Number(TotalFacturado);

    return (
      <tr key={CodVendedor || idx}>
        <td style={{ width: '150px' }}>
          <span className="text-danger fw-bold">{CodVendedor}</span> – {Nombre}
        </td>
        {user.CodGerente === 'HABOULMOUNA' && (
          <td className='text-center'>{sectores}</td>
        )}
        <td className='text-center'>{nroPedidos}</td>
        <td className='text-center'>
          <button
            className='btn btn-hover-details rounded-pill  w-100 py-2 px-3 my-1'
            onClick={() => navigate(`/orders/${CodVendedor}`)}
          >
            ${formatNumber(totalPedidoSinFlete.toFixed(2))}
          </button>
        </td>
        <td className='text-center'>
          <button
            className='btn btn-hover-details rounded-pill w-100'
            onClick={() => navigate(`/invoices/${CodVendedor}`)}
          >
            ${formatNumber(totalFacturadoSinFlete.toFixed(2))}
          </button>
        </td>
        {vendorItems.map(item => (
          <td
            key={item.Fecha}
            className={
              isWeekend(item.Fecha)
                ? 'bg-weekend text-center'
                : item.Pedidos === 0
                  ? 'bg-no-orders text-center'
                  : 'text-center'
            }
          >
            {isWeekend(item.Fecha)
              ? <span className='text-white fw-bold'>{item.Pedidos}</span>
              : item.Pedidos}
          </td>
        ))}
      </tr>
    );
  });
};


  return (
    <div style={{ overflowX: 'auto' }} className='table-responsive'>
      {/* Si no hay datos, muestro mensaje y salgo aquí */}
      {(!data || data.length === 0) ? (
        <div className="text-center py-4">
          <em>No hay vendedores para la zona o fechas seleccionadas.</em>
        </div>
      ) : (
        <>
          <div className="row mb-1">
            <h6 className="text-belmeny">
              Resumen monto pedido: {formatNumber(resumenPedido.toFixed(2))} USD
            </h6>
          </div>
          <div className="row mb-1">
            <h6 className="text-belmeny">
              Resumen monto facturado: {formatNumber(resumenFacturado.toFixed(2))} USD
            </h6>
          </div>
          <PedidosPorDiaXLS uniqueDates={finalUniqueDates} vendorData={finalVendorData} />
          <table className='table table-bordered table-hover border-belmeny'>
            <thead>{renderTableHeader()}</thead>
            <tbody>{renderTableRows()}</tbody>
          </table>
        </>
      )}
    </div>
  );
};
